import Vue from 'vue'
import VueRouter from 'vue-router'
import { Main } from './pages/Home'
import { PageSurveyDetail, PageSurveyMine, SurveyChatMain, SurveyEntry } from './pages/Survey'
import { Eating, EatingHome, EatingList, EatingDetail } from './pages/Eating'
import { Delivery } from './pages/Delivery'
import Enter from '@/pages/Interest/Enter' // 趣味测评-入口
import Examine from '@/pages/Interest/Examine' // 趣味测评-答题
import Result from '@/pages/Interest/Result' // 趣味测评-结果
import Poster from '@/pages/Interest/Poster' // 趣味测评-海报生成

const routes = [
  {
    path: '/',
    name: 'home',
    component: Main
  },
  {
    path: '/survey/entry', // query sid
    component: SurveyEntry
  },
  {
    path: '/survey/chat', // query sid
    component: SurveyChatMain
  },
  {
    path: '/survey/detail', // query id
    component: PageSurveyDetail
  },
  {
    path: '/survey/mine',
    component: PageSurveyMine
  },
  {
    path: '/eating',
    component: Eating,
    redirect: '/eating/home',
    children: [
      {
        path: 'home',
        component: EatingHome
      },
      {
        path: 'list',
        component: EatingList
      },
      {
        path: 'detail',
        component: EatingDetail
      }
    ]
  },
  {
    path: '/delivery',
    component: Delivery
  },
  {
    path: '/interest/enter',
    component: Enter
  },
  {
    path: '/interest/examine',
    component: Examine
  },
  {
    path: '/interest/result',
    component: Result
  },
  {
    path: '/interest/poster',
    component: Poster
  }
]

Vue.use(VueRouter)

const router = new VueRouter({
  routes
})

export default router
